<proffeo-ui-page-wrapper>
  <div
    pageActions
    class="flex w-full flex-col gap-3"
  >
    <div class="flex w-full justify-end">
      <proffeo-ui-button
        (clicked)="openCreateCompanyProjectDialog()"
        variant="accent"
        fontIcon="add"
        text="{{ 'company-projects.add-new' | translate }}"
      ></proffeo-ui-button>
    </div>

    <nav
      [tabPanel]="tabPanel"
      mat-tab-nav-bar
    >
      @for (link of navLinks; track $index) {
        <a
          #rla="routerLinkActive"
          [routerLink]="link.link"
          [active]="rla.isActive"
          mat-tab-link
          routerLinkActive
        >
          {{ link.label | translate }}
        </a>
      }
    </nav>
  </div>

  <proffeo-ui-card class="!border-t-0">
    <mat-tab-nav-panel #tabPanel>
      <router-outlet></router-outlet>
    </mat-tab-nav-panel>
  </proffeo-ui-card>
</proffeo-ui-page-wrapper>
